import { useServices } from './use-services';
import { useSubject } from './useSubject';

export function useUser() {
  const { userService: { userChange } } = useServices();
  return useSubject(
    userChange,
    userChange.value
  );
}
